import Grid from '@mui/material/Grid';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { HintBox, Widget } from '../../../../components';
import { useStore } from '../../../../store';
import GeneratePanel from '../../../products/edit/pulse-keys/components/GeneratePanel';
import UnusedKeysPanel from '../../../products/edit/pulse-keys/components/UnusedKeysPanel';
import Bundle from '../../store/Bundle';

export default observer(function BundleKeysPanel({
  bundle,
}: {
  bundle: Bundle;
}) {
  const { pulseKeyStore } = useStore();

  const unusedKeysQuery = useMemo(
    () => pulseKeyStore.createUnusedProductKeyQuery(bundle.id),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [bundle.id],
  );

  if (!bundle.useBundleKey) {
    return (
      <HintBox sx={{ mt: 3 }}>
        Enable &ldquo;Use a single bundle key&rdquo; on the General tab and save
        the bundle to generate bundle keys.
      </HintBox>
    );
  }

  return (
    <>
      <Widget surface="gray" sx={{ mt: 3 }} title="Create new Pulse Keys">
        <Grid container spacing={4}>
          <Grid item xs={8}>
            <GeneratePanel
              onCreated={unusedKeysQuery.execute}
              sellableId={bundle.id}
            />
          </Grid>
        </Grid>
      </Widget>

      <Widget surface="gray" sx={{ mt: 3 }} title="Export Pulse Keys">
        <Grid container spacing={4}>
          <Grid item xs={8}>
            <UnusedKeysPanel query={unusedKeysQuery} />
          </Grid>
        </Grid>
      </Widget>
    </>
  );
});
